module.exports = __webpack_public_path__ + "logo-white.png?a80f3bc740b579465e412c8eee536c9a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-white.png
// module id = 117
// module chunks = 0